import { fetchAPI } from '../utils/api';

export function getCartCost(
  data_item_ids: number[],
  shop_item_ids: number[],
  shop_item_category_ids: number[]
): Promise<GetCatalogResponse> {
  return fetchAPI(`/channels/cart/cost`, {
    method: 'POST',
    version: '1.2',
    payload: {
      data_item_ids,
      shop_item_ids,
      shop_item_category_ids,
    },
  }).then(r => r.json());
}

export function postCartInterested(
  data_item_ids: number[],
  shop_item_ids: number[],
  shop_item_category_ids: number[],
  user_info_name: string,
  user_info_email: string,
  user_info_phone: string,
  payment_plan: string,
  custom_message?: string,
  budget?: string
): Promise<number> {
  return new Promise((resolve, reject) => {
    fetch(`${__API_HOST__}/api/v1.2/channels/cart/interested`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data_item_ids,
        shop_item_ids,
        shop_item_category_ids,
        payment_plan,
        user_info: {
          name: user_info_name,
          email: user_info_email,
          phone_number: user_info_phone,
        },
        budget,
        custom_message,
      }),
    }).then(res => resolve(res.status));
  });
}



// WEBPACK FOOTER //
// ./app/api/cart.ts